import { userApi } from '../redux/api/axiosInstance';

export interface EnabledModulesResponse {
  organizationId: number;
  enabledModules: string[];
}

export interface ModuleLicenseSummaryItem {
  moduleId: number;
  moduleCode: string;
  moduleName: string;
  isEnabled: boolean;
  source: 'PLAN' | 'ADDON' | 'MANUAL';
}

export const getEnabledModules = async (): Promise<EnabledModulesResponse> => {
  const { data } = await userApi.get('modules/enabled');
  return data;
};

export const getModuleLicenseSummary = async (): Promise<ModuleLicenseSummaryItem[]> => {
  const { data } = await userApi.get('modules/license-summary');
  // API may return a plain array or a wrapped envelope { data: [...] }
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export const toggleOrgModule = async (moduleId: number, isEnabled: boolean): Promise<void> => {
  await userApi.put('modules/org-module', { moduleId, isEnabled });
};
